import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Outlet } from 'react-router-dom';
import useClasses from '../../helpers/useClasses';


import { Topbar } from './components';
import Maintenance from '../../components/UI/Maintenance'

const styles = theme => ({
  root: {
    paddingTop: 64,
    height: '100%'
  },
  content: {
    height: '100%'
  }
});

const Minimal = props => {
  const classes = useClasses(styles);

  return (
    <div className={classes.root}>
      <Maintenance /> 
      <Topbar />
      <main className={classes.content}><Outlet /></main>
    </div>
  );
};

Minimal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default Minimal;
